import type { Translator } from '@/i18n/messages';
import { useTranslation } from '@/i18n/useTranslation';
import { ApiError } from '@/api/client';

function messageFor(error: unknown, { errorText, t }: Translator): string {
  if (error instanceof ApiError) {
    return errorText(error.problem.detail || error.problem.title, error.status);
  }
  if (error instanceof Error) return errorText(error.message);
  return t('An unexpected error occurred.');
}

export function InlineError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const translation = useTranslation();
  const { t } = translation;
  return (
    <div className="error-state glass-panel" role="alert">
      <h3>{t('Something went wrong')}</h3>
      <p>{messageFor(error, translation)}</p>
      {error instanceof ApiError && error.problem.trace_id && (
        <p className="font-mono" style={{ fontSize: 'var(--font-size-xs)' }}>
          {t('Trace ID:')} {error.problem.trace_id}
        </p>
      )}
      {onRetry && (
        <button type="button" className="btn btn--secondary" onClick={onRetry}>
          {t('Try again')}
        </button>
      )}
    </div>
  );
}
